import * as React from "react";
import {ScoringMelds} from "../engine/Player";
import { END_GAME_SCORE } from '../engine/Utils';

export interface IEndGame {
    winner: any;
    endGame: boolean;
}

interface State {
    scoringIndex: number;
    scored: Boolean[];
    endGame: IEndGame;
}

export interface IEndRoundProps {
    currentRound: number;
    players: any[];
    scoringIndex: number;
    getCardShortName: any;
    crib: ScoringMelds[];
    computeScore: (currentPlayer: number, score:number) => void;
    computeMelds: (hand: any, isCrib: boolean) => ScoringMelds[];
    onResetPlay: any;
    onRestartGame: any;
    setScoringIndex: any;
    endGame: IEndGame;
}

export class EndRoundComponent extends React.Component<IEndRoundProps, State> {

    resetRoundControl: boolean = false;

    state: State = {
        scoringIndex: 0,
        scored: [false,false,false],
        endGame: {
            winner: undefined,
            endGame: false,
        }
    }

    componentDidMount() {
        this.props.setScoringIndex(this.getPlayerToScore());
    }

    getPlayerToScore = () => {
        switch(this.state.scoringIndex) {
            case 0: return this.props.players[0].isDealer ? this.props.players[1].id : this.props.players[0].id; break;
            case 1: return this.props.players[0].isDealer ? this.props.players[0].id : this.props.players[1].id; break;
            default: return 2; break;
        }
    }

    nextScore = (event: React.SyntheticEvent<HTMLButtonElement>) => {
        let scoringIndex = this.state.scoringIndex,
            cribScore = this.props.players[0].isDealer ? 0 : 1,
            scoring:number = + (event.currentTarget.dataset.score || 0),
            action = event.currentTarget.dataset.action,
            scoringPlayer: number;

        if(action === 'previous') {
            scoringIndex--;
            this.setState({scoringIndex: scoringIndex}, () => {
                this.props.setScoringIndex(this.getPlayerToScore());
            });
            return;
        }
        scoringPlayer = this.getPlayerToScore();

        if(this.state.endGame.endGame || this.props.endGame.endGame) {
            window.location.reload();
            return;
        }

        if(scoringPlayer !== 2 && this.props.players[scoringPlayer].score + scoring >= END_GAME_SCORE) {
            this.setState({
                endGame: {
                    winner: this.props.players[scoringPlayer],
                    endGame: true
                }
            })
        }

        let scored = this.state.scored;
        switch(true) {
            //players
            case (this.state.scoringIndex < 2):
                if(!scored[scoringPlayer]) {
                    this.props.computeScore(scoringPlayer, scoring);
                }
                scored[scoringPlayer] = true;
                scoringIndex++;
                this.setState({scoringIndex: scoringIndex}, () => {
                    this.props.setScoringIndex(this.getPlayerToScore());
                });
            break;
            //crib
            default:
                if(!this.resetRoundControl) {
                    this.resetRoundControl = true;
                    if(!scored[scoringPlayer]) {
                        this.props.computeScore(cribScore, scoring);
                    }
                    scored[scoringPlayer] = true;
                    if(this.props.players[cribScore].score < END_GAME_SCORE) {
                        this.props.onResetPlay();
                    }
                }
            break;
        }
    }

    scoreTable(player: any) {
        let total = 0,
            btnText = 'Next';

        if(this.state.scoringIndex === 2) {
            player = {
                name: "Crib",
                scoringMelds: this.props.crib
            }
            btnText = 'Next round';
        } else {
            //start scoring for the non dealer
            player = this.props.players[this.getPlayerToScore()];
            player.scoringMelds = this.props.computeMelds(player.hand, false);
        }

        if(player.scoringMelds.length === 0) {
            player.scoringMelds = [{
                name: '-',
                cards: '-',
                score: '-'
            }]
        }

        return (
            <div className={`end-of-round`} >
                <div className="scoreboard">
                    <table cellPadding={0} cellSpacing={0} >
                        <thead className="bold">
                            <tr>
                                <td colSpan={3}>{player.name}</td>
                            </tr>
                            <tr>
                                <td>Type</td>
                                <td>Cards</td>
                                <td>Score</td>
                            </tr>
                        </thead>
                        <tbody>
                            {player.scoringMelds.map( (meld: any, i:number) => {
                                total += meld.score !== '-' ? meld.score : 0;
                                return (
                                    <tr key={i}>
                                        <td>{meld.name}</td>
                                        <td>
                                            {meld.name === '-' ? meld.cards :
                                            <span key={i} className="meld">
                                                {meld.cards.map((card: any, i:number) =>
                                                    this.props.getCardShortName(card, i))}
                                            </span>
                                            }
                                        </td>
                                        <td>{meld.score}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="align-right bold" colSpan={2}>Total points this round:</td>
                                <td>{total}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                {this.state.scoringIndex !== 0 ? <button onClick={this.nextScore} data-score={0} data-action="previous">Previous</button> : ''}
                {<button onClick={this.nextScore} data-score={total} data-action="next">{btnText}</button>}
            </div>
        )
    }

    public render () {
        let endOfRoundHTML;

        if(this.state.endGame.endGame || this.props.endGame.endGame) {
            let winnerName = this.props.endGame.winner !== undefined ? this.props.endGame.winner.name : this.state.endGame.winner.name,
                winnerScore = this.props.endGame.winner !== undefined ? this.props.endGame.winner.score : this.state.endGame.winner.score;

            endOfRoundHTML = (
                <div className={`end-of-round`} >
                    <h1>Game over</h1>
                    <p>The winner is {winnerName} with a total score of {winnerScore}
                    </p>
                    {<button onClick={this.nextScore} data-score={0}>Play again</button>}
                </div>
            )
        } else {
            endOfRoundHTML = this.scoreTable(this.props.players)
        }

        return (
            <div className="modal">
                {endOfRoundHTML}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/EndRoundComponent.tsx